import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent';
const FmLowTco = () => {
    return (
        <div className='row px-10 mb-20'>
            <div className="col-md-12 text-center mb-20">
                <SectionHeader_2
                    title= {`Low TCO`}
                    
                />
            </div>

            <div className='row border px-10 br-20'>
                <div className='col-md-7 pe-15 m-auto'>
                    <div className='mt-6'>
                        <h3 className="title fs-1 my-4 text-gray-800">
                            Low Total Cost of Ownership (TCO)
                        </h3>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                No data collection, preparation or machine training.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                You need not deploy or engage your technical staff.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                It is the fastest way to go-to-market.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                We manage it end-to-end, including hosting and maintenance. No infrastructure to be provisioned by you.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Easy to maintain and modify your AI Agents as they have to evolve along with your business needs.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-5 text-end m-auto'>
                    <img src="/assets/img/low-tco.jpg" alt="app image" className="radius-20 p-10 pe-0" style={{}} />
                </div>
            </div>
            
        </div>
    )
}

export {FmLowTco}